import { useContext } from 'react';
import { SystemContext } from 'contexts';

const useSystem = () => useContext(SystemContext);

export { useSystem as default };
